import React from 'react';
import { SlPageTitle, SlBusyIndicator } from '../editors';
import { Row, Col } from "reactstrap";
import { metadataService } from '../../_services';

export const ApplicationProcessingView = (props) => {

    return (
        <div>
            <SlPageTitle pageName="ApplicationProcessing" />
            <Row>
                <Col>
                    <p className={"text-center"}>{metadataService.getMessage("ApplicationProcessing")}</p>
                    <p><SlBusyIndicator visible={true} /></p>
                    <p className={"text-center"}>{metadataService.getMessage("ApplicationProcessing2")}</p>
                </Col>
            </Row>
        </div>
    )

};
